<ng-container>
  <div class="modal-header">
    <h5 class="modal-title">Participant Links</h5>
  </div>
  @if (participant.participantUrl?.url) {
    <div class="modal-body clrsgn-form">
      <label for="signingLink">Copy link to signing session:</label>
      <div class="input-group mb-3">
        <input type="text"
          readonly="true"
          class="form-control"
          id="signingLink"
          [defaultValue]="participant.participantUrl?.url"
          #closingUrlInput />
          <div class="input-group-append">
            <button type="button"
              class="btn-primary copy-button input-group-text"
              [copy-to-clipboard]="participant.participantUrl?.url"
              (copied)="copySigningSessionLink()">
              <span>Copy Link</span>
            </button>
          </div>
        </div>
        @if (isSigningSessionLinkCopied) {
          <p class="primary-color-txt">
            The link has been copied!
          </p>
        }
      </div>
    }
    @if (
      participant.participantUrl?.consumerPortalUrl
      ) {
      <div
        class="modal-body clrsgn-form">
        <label for="consumerPoralLink">Copy link to consumer portal:</label>
        <div class="input-group mb-3">
          <input type="text"
            readonly="true"
            class="form-control"
            id="consumerPoralLink"
            [defaultValue]="participant.participantUrl?.consumerPortalUrl"
            #consumerPortalUrlInput />
            <div class="input-group-append">
              <button type="button"
                class="btn-primary copy-button input-group-text"
                [copy-to-clipboard]="participant.participantUrl?.consumerPortalUrl"
                (copied)="copyConsumerPortalLink()">
                <span>Copy Link</span>
              </button>
            </div>
          </div>
          @if (isConsumerPortalLinkCopied) {
            <p class="primary-color-txt">
              The link has been copied!
            </p>
          }
        </div>
      }
      <div class="modal-footer">
        <button type="button"
          class="btn-secondary close-button"
          (click)="closeModal()">
          Close
        </button>
      </div>
    </ng-container>
